/**
 * @description Примесь для работы со временем.
 * @type {Vue}
 */

const HOUSE_BEGIN = 7;

const HOUSE_FINISH = 23;
export default {
  methods: {
    /**
     * Расчитываем дефолтное время работы клиники
     *
     * @return {*[string]}
     */
    getForClinicHours() {
      const diffBetweenFinishAndBegin = HOUSE_FINISH - HOUSE_BEGIN;
      const result = [];
      for (let i = 0; i <= diffBetweenFinishAndBegin; i += 1) {
        const hours = HOUSE_BEGIN + i;
        result.push(`${hours < 10 ? `0${hours}` : hours}:00`);
      }
      return result;
    },
  },
};
